import { useContext } from "react";

import type { ITransferPopupContext } from "@/contexts/TransferPopupContext";
import { TransferPopupContext } from "@/contexts/TransferPopupContext";

export const useTransferPopup = (): ITransferPopupContext => {
  const context = useContext(TransferPopupContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === null) {
    throw new Error(
      "useTransferPopup must be used within a TransferPopupProvider",
    );
  }

  return context;
};
